import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'bg-bingo-packages-filter',
    templateUrl: './packages-filter.component.html',
    standalone: true,
})
export class PackagesFilterComponent {
    @Input() packageFilterItems: any;
    @Input() selectedFilterItem: any;
    @Output() selectItem = new EventEmitter();
    showFilterDropDown: boolean = false;

    @ViewChild('packagesFilterDropdown') packagesFilterDropdown: ElementRef;

    constructor() {}

    @HostListener('document:click', ['$event'])
    onClick(ev: MouseEvent) {
        if (this.packagesFilterDropdown && this.showFilterDropDown == true) {
            const clickInside = this.packagesFilterDropdown?.nativeElement.contains(ev.target);
            if (!clickInside) {
                this.showFilterDropDown = false;
            }
        }
    }

    toggleFilterDropDown() {
        this.showFilterDropDown = !this.showFilterDropDown;
    }

    filterOptionClicked(filterItem: any) {
        this.selectItem.emit(filterItem);
        this.toggleFilterDropDown();
    }
}
